import type { StylesConfig } from 'react-select';

// The callbacks take no arguments, so the inferred type stays assignable to
// StylesConfig for every option shape and every react-select wrapper
// (searchableSelect, clientSelect, hostSelect) can share the one config.
export const selectStyles = {
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: () => ({
    color: '#7bbb54',
    position: 'relative',
    right: '11px',
    top: '3px',
  }),
  clearIndicator: () => ({
    color: '#e8e8e8',
    position: 'relative',
    top: '3px',
    left: '-10px',
  }),
  placeholder: () => ({
    font: 'normal 500 1.6rem / 3.5rem var(--font-hind), sans-serif',
    color: '#425563',
    position: 'absolute',
  }),
  valueContainer: () => ({
    color: '#425563',
    padding: '0 1.5rem',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    position: 'relative',
    overflow: 'hidden',
  }),
  singleValue: () => ({
    font: 'normal 500 1.6rem / 3.5rem var(--font-hind), sans-serif',
    color: '#425563',
    width: '90%',
    '@media only screen and (min-width: 868px)': {
      maxWidth: '22rem',
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
} satisfies StylesConfig<unknown, boolean>;
